var map = {
	"./arrowdown.svg": "0ff5",
	"./clock.svg": "3175",
	"./committed.svg": "e7ab",
	"./noPaper.svg": "4d46",
	"./notStarted.svg": "2aac",
	"./person.svg": "7c75",
	"./question.svg": "22e2",
	"./sandclock.svg": "0e41",
	"./saved.svg": "112c",
	"./shield.svg": "a001"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";